/**
 * Mark DLQ rows resolved after a clean sync.
 */
export class ResolveEntitlementSyncFailuresRequest {
  fingerprints?: string[];
  tenantId?: number | null;
}
